import Model from './Model';
import PaymentCountry from './PaymentCountry';
import PaymentMethodChannel from './PaymentMethodChannel';

type Props = Readonly<{
    id: number;
    name: string;
    slug: string;
    transaction_currency: string;
    user_fixed_fee: string;
    user_fixed_fee_currency: string;
    user_percent_fee: string;
    image: string;
    min_payment: number | null;
    data: object | null;
    payment_countries: Array<PaymentCountry> | null;
    channels: Array<PaymentMethodChannel> | null;
    destination_account: string;
    captcha_enabled: boolean;
}>;

interface DataInterface {
    [key: string]: any;
}

export default class PaymentMethod extends Model {
    public readonly id: number;
    public readonly name: string;
    public readonly slug: string;
    public readonly transactionCurrency: string;
    public readonly userFixedFee: number;
    public readonly userFixedFeeCurrency: string;
    public readonly userPercentFee: number;
    public readonly image: string;
    public readonly data: DataInterface;
    // eslint-disable-next-line camelcase
    public readonly min_payment: number | null;
    public paymentCountries: Array<PaymentCountry>;
    public channels: Array<PaymentMethodChannel>;
    public readonly destinationAccount: string;
    public readonly captchaEnabled: boolean;

    /* eslint-disable camelcase */
    constructor(
        {
            id,
            name,
            slug,
            transaction_currency,
            user_fixed_fee,
            user_fixed_fee_currency,
            user_percent_fee,
            image,
            data,
            payment_countries,
            channels,
            min_payment,
            destination_account,
            captcha_enabled,
        }: Partial<Props>,
        jsonData?: string
    ) {
        super();

        if (jsonData) {
            const parsedData = JSON.parse(jsonData);
            this.id = parsedData.id;
            this.name = parsedData.name;
            this.slug = parsedData.slug;
            this.transactionCurrency = parsedData.transactionCurrency;
            this.userFixedFee = Number(parsedData.userFixedFee);
            this.userFixedFeeCurrency = parsedData.userFixedFeeCurrency;
            this.userPercentFee = Number(parsedData.userPercentFee);
            this.image = parsedData.image;
            this.data = parsedData.data || {};
            this.paymentCountries = parsedData.paymentCountries || [];
            this.channels = parsedData.channels || [];
            this.min_payment = parsedData.min_payment;
            this.destinationAccount = parsedData.destination_account;
            this.captchaEnabled = parsedData.captchaEnabled;
            return;
        }

        this.id = id;
        this.name = name;
        this.slug = slug;
        this.transactionCurrency = transaction_currency;
        this.userFixedFee = Number(user_fixed_fee);
        this.userFixedFeeCurrency = user_fixed_fee_currency;
        this.userPercentFee = Number(user_percent_fee);
        this.image = image;
        this.data = data || {};
        this.paymentCountries = payment_countries || [];
        this.channels = channels || [];
        this.min_payment = min_payment;
        this.destinationAccount = destination_account;
        this.captchaEnabled = captcha_enabled;
    }

    isSameCurrencyCode(currencyCode: string): boolean {
        return this.transactionCurrency === currencyCode;
    }

    isDifferentCurrencyCode(currencyCode: string): boolean {
        return !this.isSameCurrencyCode(currencyCode);
    }

    haveOneCountry(): boolean {
        return this.paymentCountries.length === 1;
    }
}
